<template>
  <div>
    <!-- banner -->
    <div class="maincontent fm-justifycenter">
      <div class="maincontent-div">
        <div class="fm-margin-bottom-10">
          <span class="maincontent-maintitle" style="color: #1252d9">
            GO家居
          </span>
          <span
            class="maincontent-title fm-margin-left-20"
            style="color: #1252d9"
          >
            业财一体化系统
          </span>
        </div>
        <div class="maincontent-content fm-margin-bottom-20">
          提高管理效率丨降低运营成本丨助力企业决策
        </div>
        <div class="maincontent-content">
          GO家居是一款亲民且专为家居企业精心设计的全面信息化应用平台。该平台旨在打通企业上下游的数据流，提供包括供应商管理、商品管理、客户管理、资金绩效管理、采购、销售、配送以及统计等在内的一体化解决方案。通过GO家居，企业能够高效整合资源，实现降低成本和提升效益的目标。
        </div>
      </div>
      <el-image
        @dragstart.prevent
        class="maincontent-img"
        src="https://fmerp.oss-cn-hangzhou.aliyuncs.com/website/banner.png"
      ></el-image>
    </div>
    <!-- 优势功能 -->
    <div class="fm-aligncenter fm-rela youshi-out">
      <div class="content">
        <div class="fm-flex fm-center">
          <el-image
            @dragstart.prevent
            class="content-titledesc"
            src="https://fmerp.oss-cn-hangzhou.aliyuncs.com/website/titledesc.png"
            fit="contain"
          ></el-image>
          <span class="content-title">优势功能</span>
          <el-image
            @dragstart.prevent
            class="content-titledesc"
            src="https://fmerp.oss-cn-hangzhou.aliyuncs.com/website/titledesc.png"
            fit="contain"
          ></el-image>
        </div>
        <div class="content-divl youshi-contentdiv">
          <div>
            <span class="content-subtitle">· 销售丨</span>
            <span class="content-content">
              优化订单处理，高效驱动，销售渠道精准可控
            </span>
          </div>
          <div>
            <span class="content-subtitle">· 商品丨</span>
            <span class="content-content">
              模块化、灵活化的商品配置与统计，灵活高效
            </span>
          </div>
          <div>
            <span class="content-subtitle">· 库存丨</span>
            <span class="content-content">
              动态库存监控，智能锁定，实现精准化管理
            </span>
          </div>
          <div>
            <span class="content-subtitle">· 客户丨</span>
            <span class="content-content">
              无缝对接下游信息，轻松拓客，抢占先机
            </span>
          </div>
          <div>
            <span class="content-subtitle">· 资金丨</span>
            <span class="content-content">
              智能分摊收支记录，实时监控资金流动
            </span>
          </div>
        </div>
        <el-image
          @dragstart.prevent
          class="content-imgr fm-justifycenter youshi-img"
          src="https://fmerp.oss-cn-hangzhou.aliyuncs.com/website/youshi.png"
          fit="contain"
        ></el-image>
      </div>
      <el-image
        @dragstart.prevent
        class="youshi-bgimg"
        src="https://fmerp.oss-cn-hangzhou.aliyuncs.com/website/youshibg.png"
      ></el-image>
    </div>
    <!-- 数据隐私保护 -->
    <div class="fm-aligncenter fm-rela yinsi-out">
      <div class="content">
        <div class="fm-flex fm-center">
          <el-image
            @dragstart.prevent
            class="content-titledesc"
            src="https://fmerp.oss-cn-hangzhou.aliyuncs.com/website/titledesc.png"
            fit="contain"
          ></el-image>
          <span class="content-title">数据隐私保护</span>
          <el-image
            @dragstart.prevent
            class="content-titledesc"
            src="https://fmerp.oss-cn-hangzhou.aliyuncs.com/website/titledesc.png"
            fit="contain"
          ></el-image>
        </div>
        <div class="fm-center">
          <el-row :gutter="40" style="width: 1100px">
            <el-col :span="8">
              <el-card class="fm-center yinsi-div">
                <div class="fm-center">
                  <el-image
                    @dragstart.prevent
                    class="yinsi-img"
                    src="https://fmerp.oss-cn-hangzhou.aliyuncs.com/website/privacy1.png"
                    fit="contain"
                  ></el-image>
                </div>
                <div class="fm-margin-top-20 yinsi-content">
                  阿里云提供技术支持，<br />
                  全方位的安全保障措施持续提供优质服务
                </div>
              </el-card>
            </el-col>
            <el-col :span="8">
              <el-card class="fm-center yinsi-div">
                <div class="fm-center">
                  <el-image
                    @dragstart.prevent
                    class="yinsi-img"
                    src="https://fmerp.oss-cn-hangzhou.aliyuncs.com/website/privacy2.png"
                    fit="contain"
                  ></el-image>
                </div>
                <div class="fm-margin-top-20 yinsi-content">
                  严格的数据隔离架构， <br />
                  确保数据的安全性和隐私性
                </div>
              </el-card>
            </el-col>
            <el-col :span="8">
              <el-card class="fm-center yinsi-div">
                <div class="fm-center">
                  <el-image
                    @dragstart.prevent
                    class="yinsi-img"
                    src="https://fmerp.oss-cn-hangzhou.aliyuncs.com/website/privacy3.png"
                    fit="contain"
                  ></el-image>
                </div>
                <div class="fm-margin-top-20 yinsi-content">
                  严格遵循数据保护原则， <br />
                  日常运营中无权擅自调用或访问客户数据
                </div>
              </el-card></el-col
            >
          </el-row>
        </div>
      </div>
    </div>
    <!-- 适用门店 -->
    <div class="fm-aligncenter fm-rela mendian-out">
      <div class="content fm-center">
        <div class="fm-flex">
          <el-image
            @dragstart.prevent
            class="content-titledesc"
            src="https://fmerp.oss-cn-hangzhou.aliyuncs.com/website/titledesc.png"
            fit="contain"
          ></el-image>
          <span class="content-title">适用门店</span>
          <el-image
            @dragstart.prevent
            class="content-titledesc"
            src="https://fmerp.oss-cn-hangzhou.aliyuncs.com/website/titledesc.png"
            fit="contain"
          ></el-image>
        </div>
        <div class="mendian-div">
          <div
            v-for="(item, index) in mendian"
            :key="index"
            :style="{
              'font-size': item.size,
              position: 'absolute',
              left: item.left,
              top: item.top,
              padding:
                '10px ' + Math.max(item.size.replace('px', ''), 30) + 'px',
              'box-shadow': '0px 4px 16px 0px #B3D5FF',
              'border-radius': '1000px',
              color: item.color || '#606266',
              background: item.bg || '#ffffff',
            }"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
    </div>
    <!-- GO家居 · APP -->
    <div class="fm-aligncenter fm-rela appd-out">
      <div class="content">
        <div class="fm-flex fm-center">
          <el-image
            @dragstart.prevent
            class="content-titledesc"
            src="https://fmerp.oss-cn-hangzhou.aliyuncs.com/website/titledesc.png"
            fit="contain"
          ></el-image>
          <span class="content-title">GO家居 · 移动端</span>
          <el-image
            @dragstart.prevent
            class="content-titledesc"
            src="https://fmerp.oss-cn-hangzhou.aliyuncs.com/website/titledesc.png"
            fit="contain"
          ></el-image>
        </div>
        <div class="content-divr appd-contentdiv">
          <div>
            <span class="content-subtitle">· 简化流程丨</span>
            <span class="content-content">
              简化操作流程，随时随地高效管理和轻松制单
            </span>
          </div>
          <div>
            <span class="content-subtitle">· 实时统计丨</span>
            <span class="content-content">
              实时数据报表，关键数据一触即达，随时掌握业务动态
            </span>
          </div>
          <div>
            <span class="content-subtitle">· 库存预警丨</span>
            <span class="content-content">
              实时监控库存状态，即时触发库存预警，库存管理高效无忧
            </span>
          </div>
          <div>
            <span class="content-subtitle">· 语音提醒丨</span>
            <span class="content-content">
              实时语音提醒，确保业务处理及时高效，提升审批效率
            </span>
          </div>
          <div>
            <span class="content-subtitle">· 简化流程丨</span>
            <span class="content-content">
              简化流程控制，实现管理需求与业务便捷性的完美平衡
            </span>
          </div>
        </div>
        <el-image
          @dragstart.prevent
          class="content-imgl appd-img"
          src="https://fmerp.oss-cn-hangzhou.aliyuncs.com/website/app.png"
          fit="contain"
        ></el-image>
      </div>
    </div>
    <!-- GO家居 · PC端 -->
    <div class="fm-aligncenter fm-rela pc-out">
      <div class="content">
        <div class="fm-flex fm-center">
          <el-image
            @dragstart.prevent
            class="content-titledesc"
            src="https://fmerp.oss-cn-hangzhou.aliyuncs.com/website/titledesc.png"
            fit="contain"
          ></el-image>
          <span class="content-title">GO家居 · PC端</span>
          <el-image
            @dragstart.prevent
            class="content-titledesc"
            src="https://fmerp.oss-cn-hangzhou.aliyuncs.com/website/titledesc.png"
            fit="contain"
          ></el-image>
        </div>
      </div>
      <div class="content pc-rule">
        <div class="content-divl pc-contentdiv">
          <div class="pc-title">· 灵活权限设计 ·</div>
          <div>
            精心设计的权限系统，完美适配复杂的权限需求，兼顾系统安全性与灵活性
          </div>
        </div>
        <el-image
          @dragstart.prevent
          class="content-imgr pc-rule-img"
          src="https://fmerp.oss-cn-hangzhou.aliyuncs.com/website/rule.png"
          fit="contain"
        ></el-image>
      </div>
      <div class="content pc-report">
        <div class="content-divr pc-contentdiv pc-report-content">
          <div class="pc-title">· 实时报表 ·</div>
          <div>
            数据实时统计并更新，通过多种形式的报表直观呈现系统数据，为决策提供即时、准确的数据支持
          </div>
        </div>
        <el-image
          @dragstart.prevent
          class="content-imgr pc-report-img"
          src="https://fmerp.oss-cn-hangzhou.aliyuncs.com/website/report.png"
          fit="contain"
        ></el-image>
      </div>
      <div class="content pc-commodity">
        <div class="content-divl pc-contentdiv">
          <div class="pc-title">· 商品结构优化 ·</div>
          <div>
            采用多商品规格形式，并支持套装销售，全面满足各类销售和采购场景需求
          </div>
        </div>
        <el-image
          @dragstart.prevent
          class="content-imgr pc-commodity-img"
          src="https://fmerp.oss-cn-hangzhou.aliyuncs.com/website/commodity.png"
          fit="contain"
        ></el-image>
      </div>
      <div class="content pc-flow">
        <div class="content-divr pc-contentdiv pc-flow-content">
          <div class="pc-title">· 全新单据流程 ·</div>
          <div>
            严谨的流程设计确保每一件货、每一分钱都有据可循，实现单据处理的规范化与透明化
          </div>
        </div>
        <el-image
          @dragstart.prevent
          class="content-imgr pc-flow-img"
          src="https://fmerp.oss-cn-hangzhou.aliyuncs.com/website/flow.png"
          fit="contain"
        ></el-image>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Fmerpv2WebLoginMain",

  data() {
    return {
      mendian: [
        {
          name: "全屋定制",
          size: "26px",
          left: "40px",
          top: "0",
        },
        {
          name: "建材",
          size: "26px",
          left: "230px",
          top: "50px",
        },
        {
          name: "橱柜",
          size: "26px",
          left: "380px",
          top: "20px",
        },
        {
          name: "定制家具",
          size: "30px",
          left: "530px",
          top: "40px",
          color: "#ffffff",
          bg: "linear-gradient(180deg, #2B70D9 0%, #0A49DA 99%)",
        },
        {
          name: "厨房电器",
          size: "30px",
          left: "20px",
          top: "90px",
          color: "#ffffff",
          bg: "linear-gradient(180deg, #2B70D9 0%, #0A49DA 99%)",
        },
        {
          name: "家具零售",
          size: "48px",
          left: "190px",
          top: "150px",
          color: "#ffffff",
          bg: "linear-gradient(180deg, #2B70D9 0%, #0A49DA 99%)",
        },
        {
          name: "衣柜",
          size: "26px",
          left: "500px",
          top: "120px",
        },
        {
          name: "智能家居",
          size: "26px",
          left: "0",
          top: "190px",
        },
        {
          name: "家用电器",
          size: "30px",
          left: "490px",
          top: "205px",
          color: "#ffffff",
          bg: "linear-gradient(180deg, #2B70D9 0%, #0A49DA 99%)",
        },
        {
          name: "寝具",
          size: "26px",
          left: "90px",
          top: "270px",
        },
        {
          name: "其他零售行业",
          size: "26px",
          left: "220px",
          top: "260px",
        },
        {
          name: "卫浴",
          size: "26px",
          left: "470px",
          top: "285px",
        },
      ],
    };
  },

  mounted() {},

  methods: {},
};
</script>

<style lang="scss" scoped>
.maincontent {
  height: 36.875vw;
  min-height: 479.375px;
  position: relative;

  &-div {
    position: relative;
    left: 100px;
    width: 550px;
    z-index: 1;
    margin-top: 70px;
  }

  &-maintitle {
    font-size: 48px;
    font-weight: bold;
    margin-bottom: 10px;
  }

  &-title {
    font-size: 28px;
    font-weight: bold;
    margin-bottom: 20px;
  }

  &-content {
    font-size: 20px;
    line-height: 28px;
    margin-bottom: 10px;
    text-align: justify;
  }

  &-img {
    height: 36.875vw;
    min-height: 479.375px;
    position: absolute;
    left: 0;
    top: 0;
  }

  &-bg {
    background-color: #fff9f6;
  }
}

.content {
  position: relative;
  font-size: 16px;
  width: 1100px;

  &-divl {
    position: relative;
    width: 600px;
    z-index: 1;
    left: 10px;
    font-size: 18px;
    > * {
      padding-bottom: 8px;
    }
  }

  &-divr {
    position: relative;
    width: 650px;
    z-index: 1;
    left: 480px;
    font-size: 18px;
    margin-bottom: 20px;

    > * {
      padding-bottom: 8px;
    }
  }

  &-title {
    font-size: 42px;
    font-weight: bold;
  }

  &-titledesc {
    width: 53px;
    height: 38px;
    margin: 75px 30px;
  }

  &-subtitle {
    font-size: 20px;
    line-height: 40px;
    font-weight: bold;
    color: #195bda;
    margin-bottom: 20px;
  }

  &-content {
    font-size: 20px;
    line-height: 40px;
    margin-bottom: 20px;
  }

  &-imgr {
    width: 650px;
    height: 441px;
  }
  &-imgl {
    width: 650px;
    height: 441px;
  }
}

.youshi {
  &-out {
    height: 682px;
  }

  &-contentdiv {
    margin-top: 80px;
  }

  &-img {
    width: 588px;
    height: 515px;
    position: absolute;
    right: 0;
    top: 120px;
    scale: 0.8;
  }

  &-bgimg {
    width: 1920px;
    height: 682px;
    position: absolute;
    right: 0;
    top: 0;
    z-index: -1;
  }
}

.yinsi {
  &-out {
    background-color: #ebf4ff;
  }
  &-div {
    height: 250px;
    margin-bottom: 60px;
  }
  &-img {
    width: 100px;
    height: 100px;
  }

  &-content {
    width: 230px;
    text-align: center;
    line-height: 1.3em;
    height: 3.9em;
  }
}

.mendian {
  &-out {
    background-color: #fbfbfd;
    height: 582px;
  }

  &-div {
    width: 720px;
    height: 400px;
    position: relative;
    margin-left: 30px;
  }
}

.appd {
  &-out {
    background-color: #ebf4ff;
    height: 632px;
  }

  &-contentdiv {
    margin-top: 80px;
  }

  &-img {
    width: 488px;
    height: 452px;
    position: absolute;
    left: 0;
    top: 150px;
    scale: 0.8;
  }
}

.pc {
  &-out {
    background-color: #fbfbfd;
  }

  &-title {
    font-size: 32px;
    font-weight: bold;
    margin-bottom: 20px;
  }

  &-contentdiv {
    margin-left: 50px;
    margin-top: 100px;
    width: 400px;
  }

  &-rule {
    margin: 0 0;
    height: 400px;

    &-img {
      width: 855px * 0.7;
      height: 514px * 0.7;
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  &-report {
    margin: 0 0;
    height: 500px;

    &-content {
      width: 400px;
      left: 600px;
    }

    &-img {
      width: 905px * 0.7;
      height: 601px * 0.7;
      position: absolute;
      left: 0;
      top: 0;
    }
  }

  &-commodity {
    margin: 0 0;
    height: 500px;

    &-img {
      width: 848px * 0.7;
      height: 491px * 0.7;
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  &-flow {
    margin: 0 0;
    height: 500px;

    &-content {
      width: 400px;
      left: 600px;
    }

    &-img {
      width: 857px * 0.7;
      height: 491px * 0.7;
      position: absolute;
      left: 0;
      top: 0;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/login/LoginMain.vue